import DaysForConfirmWidget from "@/pages/employee/permission/widgets/DaysForConfirmWidget.vue";
import DaysConfirmedWidget from "@/pages/employee/permission/widgets/DaysConfirmedWidget.vue";
import DaysRejectedWidget from "@/pages/employee/permission/widgets/DaysRejectedWidget.vue";

export { DaysForConfirmWidget, DaysConfirmedWidget, DaysRejectedWidget };
